/* eslint-disable */
import get from 'lodash.get';
import cloneDeep from 'lodash.clonedeep';
import AuctionClient from '@/api/AuctionClient';
import Auction from '@/models/Auction';
import RunListClient from '@/api/RunListClient';
import Analytics from '@/mixins/Analytics';

export default {
  state: {
    auctionId: 0,
    proxy: false,
    isPersistent: false,
    isRunList: false,
    userHasCurrentProxy: false,
    pendingBids: [],
  },
  mutations: {
    setBiddingAuction(state, biddingAuction) {
      state.auctionId = biddingAuction.auctionId;
      state.proxy = biddingAuction.proxy;
      state.isPersistent = biddingAuction.isPersistent;
      state.isRunList = biddingAuction.isRunList;
      state.userHasExistingRunListProxy = biddingAuction.userHasExistingRunListProxy;
    },
  },
  actions: {
    setBiddingAuctionData( { commit }, biddingAuction) {
      commit('setBiddingAuction', biddingAuction);
    },
    resetBiddingState( { commit }) {
      commit('setBiddingAuction', { auctionId: 0, highBidAmount: 0, proxy: false, isPersistent: false, });
    },
    async submitRunListBid({ state, dispatch, rootGetters, rootState }, params) {
      const runListClient = new RunListClient(rootGetters.currentUser);
      const auctionClient = new AuctionClient(rootGetters.currentUser);
      try {

        await runListClient.submitRunListBid(
          state.auctionId,
          params.amount,
          rootGetters.currentUser.id,
          params.proxy,
          params.persistent
        );

        if (import.meta.env.VITE_ENV_NAME !== 'development' || rootState.devTools.analyticsLoggingEnabled) {
          Analytics.methods.track(Analytics.data().eventNames.proxyScheduled, params.telemetryData);
        }

        const response = await auctionClient.get(state.auctionId);
        if (response.data) {
          const auction = new Auction(response.data, rootGetters.currentUser);
          dispatch('auctions/updateRunListAuction', { auction });
        }
      } catch(error) {
        const errorData = get(error, 'data.data');
        return Promise.reject(errorData);
      }

    },
    async submitBid({ state, rootState }, params) {
      const { user } = this.state.authorization;
      const auctionClient = new AuctionClient(user);
      const bidResponse = await auctionClient.submitBid(
        state.auctionId,
        params.amount,
        user.id,
        params.proxy,
        params.persistent,
      );

      if (import.meta.env.VITE_ENV_NAME !== 'development' || rootState.devTools.analyticsLoggingEnabled) {
        Analytics.methods.track(Analytics.data().eventNames.bidPlaced, params.telemetryData, { withPendo: true, withMixpanel: false });
      }

      return bidResponse;
    },
    async getProxyBid({ state }) {
      const { user } = this.state.authorization;
      const auctionClient = new AuctionClient(user);
      const response = await auctionClient.getProxyBid(state.auctionId);
      return response;
    },
    async updatePersistentProxy({ state, dispatch }, params) {
      const { user } = this.state.authorization;
      const auctionClient = new AuctionClient(user);
      const response = await auctionClient.updatePersisentProxy(state.auctionId, user.id, params.amount);
      await dispatch('updateAuctionProxyBid', {
          is_persistent: true,
          amount: get(response, 'amount', params.amount),
      });
      return response;
    },
    async cancelPersisentProxy({ state, dispatch }) {
      const { user } = this.state.authorization;
      const auctionClient = new AuctionClient(user);
      const response = await auctionClient.cancelPersisentProxy(state.auctionId, user.id);
      await dispatch('updateAuctionProxyBid', null);

      // Update the auction so the parent panel is refreshed correctly
      const refreshResponse = await auctionClient.get(state.auctionId);
      if (refreshResponse.data) {
        const auction = new Auction(refreshResponse.data, user);
        auction.auction.alert_message = '';
        auction.auction.auction_alert_text = '';
        dispatch('auctions/updateRunListAuction', { auction });
      }
      return response;
    },
    updateAuctionProxyBid({ state, dispatch, getters, }, proxyBid) {
      const auction = getters['auctions/getAuctionFromCache'](state.auctionId);
      const updatedAuction = cloneDeep(auction);
      updatedAuction.auction.proxy_bid = proxyBid;
      dispatch('auctions/updateEndedAuction', { auction: updatedAuction});
      dispatch('auctions/updateActiveAuction', { auction: updatedAuction});
    },
  },
  getters: {
    biddingAuction: (state, getters) => {
      const auction = getters['auctions/getAuctionFromCache'](state.auctionId);
      return {
        auctionId: state.auctionId,
        proxy: state.proxy,
        isPersistent: state.isPersistent,
        highBidAmount: get(auction, 'highBidAmount')
          || get(auction, 'bidAmount')
          || get(auction, 'startPrice'),
        proxyBidInterval: get(auction, 'proxyBidInterval'),
        bidIncrement: get(auction, 'bidIncrement'),
        proxyBidAmount: get(auction, 'proxyBidAmount'),
        proxyBidIsPersistent: get(auction, 'proxyBidIsPersistent'),
        isActive: get(auction, 'isActive'),
        isRunList: state.isRunList,
        status: get(auction, 'status'),
        floorPrice: get(auction, 'floorPrice'),
        isPrivateAuction: auction?.isPrivateAuction || false,
        startPrice: get(auction, 'startPrice'),
      };
    },
    isEditingPersistentProxy: state => {
      return state.isPersistent;
    },
    isEditingRunListProxy: state => {
      return state.isRunList && state.userHasExistingRunListProxy;
    }
  },
};
